import { InfoWindow } from "@react-google-maps/api";

import React, { useContext } from "react";

import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import Link from "next/link";
import { useRouter, usePathname } from "../../../hooks/useNavigation";
import PropTypes from "prop-types";
import styled from "styled-components";

import ComponentContext from "../../../../contexts/ComponentContext";
import { useStores } from "../../../../contexts/StoreContext";
import getQueryString from "../../../helpers/getQueryString/getQueryString";

const StyledWrapper = styled.div`
  position: relative;
  padding: 0.5rem;
  margin: auto;
  text-align: center;
  width: 120px;

  h5 {
    font-size: 0.8rem;
    margin: 0;
    margin-bottom: 0.25rem;
  }

  p {
    margin: 0;
    font-size: 0.7rem;
  }
`;

const StyledLink = styled.a`
  width: 100%;
  color: black;
`;

function MapInfoBox(props) {
  const { state } = props;
  const { companyId, displayName, totalVacancies, identifier } = state;

  const router = useRouter();
  const ogPathname = usePathname();

  const { filtersStore } = useStores();
  const { resetFilters } = filtersStore;
  const { resultsUrl, useIdentifierAsUrl } = useContext(ComponentContext);

  const pathname = isEmpty(resultsUrl) ? ogPathname : resultsUrl;
  const query = getQueryString({ companyId });
  const handleClick = () => {
    if (useIdentifierAsUrl) {
      router.push(identifier);
    } else {
      router
        .push({ pathname, query }, undefined, {
          shallow: true,
        })
        .then(() => resetFilters());
    }
  };

  return (
    <InfoWindow position={state.coords}>
      <StyledWrapper id="map-info-box">
        <Link
          href={useIdentifierAsUrl ? identifier : { pathname, query }}
          passHref
          legacyBehavior
        >
          <StyledLink
            className="text-decoration-none"
            onClick={handleClick}
            type="button"
          >
            <h5 className="fw-bold text-uppercase text-black">{displayName}</h5>
            <p className="text-black">{`${totalVacancies} Jobs`}</p>
          </StyledLink>
        </Link>
      </StyledWrapper>
    </InfoWindow>
  );
}

MapInfoBox.propTypes = {
  state: PropTypes.shape({
    companyId: PropTypes.string,
    coords: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    ),
    displayName: PropTypes.string,
    logoUrlFull: PropTypes.string,
    totalVacancies: PropTypes.number,
    identifier: PropTypes.string,
  }).isRequired,
};

export default observer(MapInfoBox);
